import { getField, updateField } from "vuex-map-fields";
import axios from "@/plugins/axios";

const companyInfoForm = () => {
  return {
    website: "",
    excludeWebsite: false,
    naicsCode: {},
    addressLine1: "",
    addressLine2: "",
    zipCode: "",
    state: "",
    city: "",
    companyType: "",
    yearEstablished: "",
    revenue: "",
    noOfEmployees: "",
  };
};

export default {
  namespaced: true,
  state: () => ({
    companyinformationDialog: false,
    isAnalyzing: false,
    isLoading: false,
    companyInfo: companyInfoForm(),
    premiumData: null,
  }),

  mutations: {
    updateField,

    setPremiumData(state, payload) {
      state.premiumData = payload;
    },

    resetCompanyInfo(state) {
      state.companyInfo = companyInfoForm();
    },
  },

  actions: {
    async runAnalysis({ commit }, payload) {
      try {
        const { data } = await axios.post(`/organization_premium/${payload.organization_id}`, {
          company_info: payload.company_info,
        });
        commit("setPremiumData", data);
        if (data.success) commit("resetCompanyInfo");
        return data;
      } catch (e) {
        console.error(e);
      }
    },

    async getPremium({ commit }, payload) {
      try {
        const { data } = await axios.get(`/organization_premium/${payload.organization_id}`);
        commit("setPremiumData", data);
        return data;
      } catch (e) {
        console.error(e);
      }
    },
  },
  getters: {
    getField,
  },
};
